import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchDemoRows, seedDemo } from "@/api/demo";

export function useDemoRows(enabled = true) {
  return useQuery({
    queryKey: ["demo"],
    queryFn: fetchDemoRows,
    enabled,
  });
}

export function useSeedDemo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (slug: string) => seedDemo(slug),
    // A seed creates (or replaces) an organization and its users, so every list that could show
    // them is refetched — the Demo rows themselves, and the Users blotter, which keeps demo users.
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["demo"] });
      queryClient.invalidateQueries({ queryKey: ["organizations"] });
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}
